'use es6';

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getEmailMetadata } from 'conversations-message-history/common-message-format/operators/getEmailMetadata';
import { getPlainText, getRichText } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { isLiveChatPlainText } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import ContentText from '../primary-message/ContentText';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageContent = ({
  className,
  message,
  plainTextMode,
  showTruncatedMessageContent
}) => {
  const messageBodyRichText = getRichText(message);
  const isPlainText = plainTextMode || isLiveChatPlainText(message) || !messageBodyRichText;
  const contentText = isPlainText ? getPlainText(message) : messageBodyRichText;
  const hasEmailMetadata = !!getEmailMetadata(message);
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(ContentText, {
      className: className,
      contentText: contentText,
      isPlainText: isPlainText,
      isShowingMessageReplies: showTruncatedMessageContent,
      dataTestId: hasEmailMetadata ? 'email-message-content' : 'primary-message-content'
    })
  });
};
MessageContent.displayName = 'MessageContent';
MessageContent.propTypes = {
  className: PropTypes.string,
  message: PropTypes.oneOfType([RecordPropType('CommonMessage'), RecordPropType('WorkflowGeneratedUserMessage')]).isRequired,
  plainTextMode: PropTypes.bool.isRequired,
  showTruncatedMessageContent: PropTypes.bool.isRequired
};
export default MessageContent;